import { Switch } from "@mui/material";
import colors from "assets/theme/base/colors";
import * as React from "react";

const MDSwitch = ({ checked = false, onChange, name }) => {
  const { info } = colors;

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      name={name}
      sx={{
        "& .MuiSwitch-switchBase": {
          color: checked ? "" : "",
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: checked ? `${info.main} !important` : "",
          border: checked ? `transparent !important` : "transparent !important",
        },
        "& .MuiSwitch-track": {
          backgroundColor: checked ? `${info.main} !important` : "",
          border: checked ? `1px solid ${info.main} !important` : "",
          opacity: "0.8 !important",
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: `${info.main} !important`,
          border: checked ? `1px solid ${info.main} !important` : "",
          opacity: "0.8 !important",
        },
        "& .MuiSwitch-thumb.Mui-checked": {
          "border-color": checked ? `1px solid ${info.main} !important` : "",
        },
      }}
    />
  );
};

export default MDSwitch;
